import {
  FETCH_ZONIFICACION,
  FETCH_ZONIFICACION_SUCCESS,
  FETCH_ZONIFICACION_FAILED,
  EDIT_ZONIFICACION,
  FETCH_ZONIFICACION_CODES_SUCCESS,
} from '../store/types';

const INITIAL_STATE = {
  cities: null,
  codesByCity: {},
  loading: false,
  error: {
    flag: false,
    msg: null,
  },
};

export const zonificacionreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ZONIFICACION:
      return { ...state, loading: true };
    case FETCH_ZONIFICACION_SUCCESS:
      return {
        ...state,
        cities: action.payload,
        loading: false,
        error: { flag: false, msg: null },
      };
    case FETCH_ZONIFICACION_FAILED:
      return {
        ...state,
        cities: null,
        loading: false,
        error: { flag: true, msg: action.payload },
      };
    case FETCH_ZONIFICACION_CODES_SUCCESS:
      return {
        ...state,
        codesByCity: {
          ...state.codesByCity,
          [action.payload.cityId]: action.payload.codes,
        },
      };
    case EDIT_ZONIFICACION:
      return state;
    default:
      return state;
  }
};
